/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Lean row for the applicant Activity timeline --- full snapshot is fetched per-interview on demand.
 * @export
 * @interface InterviewSummary
 */
export interface InterviewSummary {
  /**
   *
   * @type {string}
   * @memberof InterviewSummary
   */
  applicationInterviewId: string;
  /**
   *
   * @type {string}
   * @memberof InterviewSummary
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof InterviewSummary
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof InterviewSummary
   */
  summaryShort?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof InterviewSummary
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof InterviewSummary
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the InterviewSummary interface.
 */
export function instanceOfInterviewSummary(
  value: object,
): value is InterviewSummary {
  if (
    !("applicationInterviewId" in value) ||
    value["applicationInterviewId"] === undefined
  )
    return false;
  return true;
}

export function InterviewSummaryFromJSON(json: any): InterviewSummary {
  return InterviewSummaryFromJSONTyped(json, false);
}

export function InterviewSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InterviewSummary {
  if (json == null) {
    return json;
  }
  return {
    applicationInterviewId: json["applicationInterviewId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function InterviewSummaryToJSON(json: any): InterviewSummary {
  return InterviewSummaryToJSONTyped(json, false);
}

export function InterviewSummaryToJSONTyped(
  value?: InterviewSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationInterviewId: value["applicationInterviewId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
